import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a trash icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/trash-can?f=classic&s=regular
 */
export function TrashCanIcon(props: CustomIconProps) {
  return <Icon icon={faTrashCan} {...props} />;
}
